import { useState } from "react";
import { api, formatErr } from "../lib/api";
import { toast } from "sonner";
import { Handshake } from "lucide-react";

const TIERS = [
    { value: "partner", label: "Partner — Brand placement" },
    { value: "gold", label: "Gold — Premium visibility" },
    { value: "platinum", label: "Platinum — Title sponsor" },
    { value: "custom", label: "Custom — Talk to us" },
];

export default function SponsorLeadForm() {
    const [form, setForm] = useState({
        company_name: "", contact_name: "", email: "", phone: "",
        interested_tier: "partner", budget: "", message: "",
    });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/sponsor-leads", form);
            toast.success("Thanks — the front office will reach out within 48 hours.");
            setForm({ company_name: "", contact_name: "", email: "", phone: "", interested_tier: "partner", budget: "", message: "" });
        } catch (err) { toast.error(formatErr(err)); }
        finally { setLoading(false); }
    };

    return (
        <div className="card-flat p-8 md:p-10" data-testid="sponsor-lead-form">
            <Handshake className="text-gold" size={28} />
            <h2 className="h-display text-3xl md:text-4xl mt-4">Become a Sponsor</h2>
            <p className="text-ink text-sm mt-3 leading-relaxed">
                Activate your brand alongside the kingdom. Tell us where you want to play — we'll bring the audience.
            </p>
            <form onSubmit={submit} className="grid sm:grid-cols-2 gap-4 mt-7">
                <Field testid="sl-company" label="Company Name" required>
                    <input data-testid="sl-company" required value={form.company_name} onChange={(e) => setForm({ ...form, company_name: e.target.value })} className="w-full px-4 py-3 text-sm" />
                </Field>
                <Field testid="sl-contact" label="Contact Name" required>
                    <input data-testid="sl-contact" required value={form.contact_name} onChange={(e) => setForm({ ...form, contact_name: e.target.value })} className="w-full px-4 py-3 text-sm" />
                </Field>
                <Field testid="sl-email" label="Email" required>
                    <input data-testid="sl-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full px-4 py-3 text-sm" />
                </Field>
                <Field testid="sl-phone" label="Phone (Optional)">
                    <input data-testid="sl-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="w-full px-4 py-3 text-sm" />
                </Field>
                <Field testid="sl-tier" label="Interested Tier">
                    <select data-testid="sl-tier" value={form.interested_tier} onChange={(e) => setForm({ ...form, interested_tier: e.target.value })} className="w-full px-4 py-3 text-sm">
                        {TIERS.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
                    </select>
                </Field>
                <Field testid="sl-budget" label="Budget Range (Optional)">
                    <input data-testid="sl-budget" placeholder="$5K-$10K, $25K+, etc." value={form.budget} onChange={(e) => setForm({ ...form, budget: e.target.value })} className="w-full px-4 py-3 text-sm" />
                </Field>
                <div className="sm:col-span-2">
                    <Field testid="sl-msg" label="Message (Optional)">
                        <textarea data-testid="sl-message" rows={4} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full px-4 py-3 text-sm" placeholder="Tell us about your brand goals and how you'd like to activate." />
                    </Field>
                </div>
                <div className="sm:col-span-2">
                    <button type="submit" disabled={loading} data-testid="sl-submit" className="btn-gold px-7 py-4 text-xs disabled:opacity-60">
                        {loading ? "Sending…" : "Request Sponsorship Info"}
                    </button>
                </div>
            </form>
        </div>
    );
}

function Field({ label, required, children, testid }) {
    return (
        <label className="block" data-testid={`field-${testid}`}>
            <div className="text-[10px] tracking-[0.3em] uppercase text-ink font-bold mb-2">
                {label} {required && <span className="text-gold">*</span>}
            </div>
            {children}
        </label>
    );
}
